<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="settings-page">
    <v-container fluid>
      <!-- Page Header -->
      <div class="d-flex justify-space-between align-center mb-6">
        <div>
          <h1 class="text-h4 font-weight-bold mb-2">الإعدادات</h1>
          <p class="text-body-1 text-grey">إدارة إعدادات النظام والصلاحيات</p>
        </div>
        <!-- <v-btn
          color="primary"
          prepend-icon="mdi-cog"
          size="large"
        >
          حفظ الإعدادات
        </v-btn> -->
      </div>

      <!-- Settings Tabs -->
      <v-card v-if="hasAnySettingsAccess">
        <v-tabs
          v-model="activeTab"
          color="primary"
          grow
        >
          <v-tab v-if="hasModule('mail-priorities')" value="priorities">
            <v-icon start>mdi-flag</v-icon>
            أولويات المراسلات
          </v-tab>
          <v-tab v-if="hasModule('roles')" value="roles">
            <v-icon start>mdi-account-multiple</v-icon>
            إدارة الأدوار
          </v-tab>
          <v-tab v-if="hasModule('file-types')" value="attachments">
            <v-icon start>mdi-paperclip</v-icon>
            أنواع المرفقات
          </v-tab>
          <v-tab v-if="hasModule('department-jobs')" value="department-jobs">
            <v-icon start>mdi-briefcase</v-icon>
            وظائف الأقسام
          </v-tab>
          <v-tab v-if="hasModule('employee-titles')" value="employee-titles">
            <v-icon start>mdi-badge-account</v-icon>
            المسميات الوظيفية
          </v-tab>
          <v-tab v-if="hasModule('mail-template-categories')" value="template-categories">
            <v-icon start>mdi-folder-text</v-icon>
            فئات القوالب
          </v-tab>
          <v-tab v-if="hasModule('mail-types')" value="mail-types">
            <v-icon start>mdi-email-variant</v-icon>
            أنواع المراسلات
          </v-tab>
        </v-tabs>

        <v-window v-model="activeTab">
          <!-- Mail Priorities Tab -->
          <v-window-item v-if="hasModule('mail-priorities')" value="priorities">
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center mb-4">
                <h2 class="text-h5">أولويات المراسلات</h2>
                <v-btn
                  v-action="{ module: 'mail-priorities', action: 'store' }"
                  color="primary"
                  prepend-icon="mdi-plus"
                  @click="openAddPriorityDialog"
                >
                  إضافة أولوية جديدة
                </v-btn>
              </div>

              <v-data-table
                :headers="priorityHeaders"
                :items="priorities"
                :search="prioritySearch"
                :loading="loading"
                color="primary"
        first-icon="mdi-chevron-left"
        last-icon="mdi-chevron-right"
        next-icon="mdi-chevron-right"
        prev-icon="mdi-chevron-left"
        show-current-page
        show-first-last-page
        show-first-page
        show-last-page
        show-next-page
        show-previous-page
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="prioritySearch"
                    prepend-inner-icon="mdi-magnify"
                    label="بحث في الأولويات"
                    variant="outlined"
                    density="compact"
                    class="mx-4 mt-4"
                  ></v-text-field>
                </template>

                <template v-slot:item.active="{ item }">
                  <v-chip
                    :color="(item.active === 1 || item.active === true) ? 'success' : 'error'"
                    :text="(item.active === 1 || item.active === true) ? 'مفعل' : 'معطل'"
                    size="small"
                  ></v-chip>
                </template>

                <template v-slot:item.created_at="{ item }">
                  {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    v-permission="PERMISSIONS.MAIL_PRIORITIES_EDIT"
                    icon
                    variant="text"
                    size="small"
                    color="primary"
                    @click="editPriority(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    v-permission="PERMISSIONS.MAIL_PRIORITIES_DELETE"
                    icon
                    variant="text"
                    size="small"
                    color="error"
                    @click="deletePriority(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-window-item>

          <!-- Roles Management Tab -->
          <v-window-item v-if="hasModule('roles')" value="roles">
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center mb-4">
                <h2 class="text-h5">إدارة الأدوار والصلاحيات</h2>
                <v-btn
                  v-action="{ module: 'roles', action: 'store' }"
                  color="primary"
                  prepend-icon="mdi-plus"
                  @click="showRoleDialog = true"
                >
                  إضافة دور جديد
                </v-btn>
              </div>

              <v-data-table
                :headers="roleHeaders"
                :items="roles"
                :search="roleSearch"
                color="primary"
        first-icon="mdi-chevron-left"
        last-icon="mdi-chevron-right"
        next-icon="mdi-chevron-right"
        prev-icon="mdi-chevron-left"
        show-current-page
        show-first-last-page
        show-first-page
        show-last-page
        show-next-page
        show-previous-page
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="roleSearch"
                    prepend-inner-icon="mdi-magnify"
                    label="بحث في الأدوار"
                    variant="outlined"
                    density="compact"
                    class="mx-4 mt-4"
                  ></v-text-field>
                </template>

                <template v-slot:item.permissions="{ item }">
                  <v-chip
                    v-for="permName in item.permissionNames?.slice(0, 3) || []"
                    :key="permName"
                    size="small"
                    class="me-1 mb-1"
                  >
                    {{ permName }}
                  </v-chip>
                  <v-chip
                    v-if="(item.permissionNames?.length || 0) > 3"
                    size="small"
                    color="grey"
                  >
                    +{{ (item.permissionNames?.length || 0) - 3 }}
                  </v-chip>
                  <span v-if="!item.permissionNames?.length" class="text-grey">
                    لا توجد صلاحيات
                  </span>
                </template>

                <template v-slot:item.created_at="{ item }">
                  {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="primary"
                    @click="editRole(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="info"
                    @click="viewRolePermissions(item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-window-item>

          <!-- Attachment Types Tab -->
          <v-window-item v-if="hasModule('file-types')" value="attachments">
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center mb-4">
                <h2 class="text-h5">أنواع المرفقات المسموحة</h2>
                <v-btn
                  color="primary"
                  prepend-icon="mdi-plus"
                  @click="openAddAttachmentDialog"
                >
                  إضافة نوع جديد
                </v-btn>
              </div>

              <v-data-table
                :headers="attachmentHeaders"
                :items="attachmentTypes"
                :search="attachmentSearch"
                color="primary"
        first-icon="mdi-chevron-left"
        last-icon="mdi-chevron-right"
        next-icon="mdi-chevron-right"
        prev-icon="mdi-chevron-left"
        show-current-page
        show-first-last-page
        show-first-page
        show-last-page
        show-next-page
        show-previous-page
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="attachmentSearch"
                    prepend-inner-icon="mdi-magnify"
                    label="بحث في أنواع المرفقات"
                    variant="outlined"
                    density="compact"
                    class="mx-4 mt-4"
                  ></v-text-field>
                </template>

                <template v-slot:item.icon="{ item }">
                  <v-icon :icon="item.icon" :color="item.color"></v-icon>
                </template>

                <template v-slot:item.max_size="{ item }">
                  {{ formatFileSize(item.max_size) }}
                </template>

                <template v-slot:item.active="{ item }">
                  <v-chip
                    :color="item.active ? 'success' : 'error'"
                    variant="flat"
                    size="small"
                  >
                    {{ item.active ? 'مفعل' : 'معطل' }}
                  </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="primary"
                    @click="editAttachmentType(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="error"
                    @click="deleteAttachmentType(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-window-item>

          <!-- Department Jobs Tab -->
          <v-window-item v-if="hasModule('department-jobs')" value="department-jobs">
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center mb-4">
                <h2 class="text-h5">وظائف الأقسام</h2>
                <v-btn
                  color="primary"
                  prepend-icon="mdi-plus"
                  @click="openAddDepartmentJobDialog"
                >
                  إضافة وظيفة جديدة
                </v-btn>
              </div>

              <v-data-table
                :headers="departmentJobHeaders"
                :items="departmentJobs"
                :search="departmentJobSearch"
                :loading="loading"
                color="primary"
        first-icon="mdi-chevron-left"
        last-icon="mdi-chevron-right"
        next-icon="mdi-chevron-right"
        prev-icon="mdi-chevron-left"
        show-current-page
        show-first-last-page
        show-first-page
        show-last-page
        show-next-page
        show-previous-page
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="departmentJobSearch"
                    prepend-inner-icon="mdi-magnify"
                    label="بحث في الوظائف"
                    variant="outlined"
                    density="compact"
                    class="mx-4 mt-4"
                  ></v-text-field>
                </template>

                <template v-slot:item.department_name="{ item }">
                  {{ getDepartmentName(item.department_id) }}
                </template>

                <template v-slot:item.created_at="{ item }">
                  {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="primary"
                    @click="editDepartmentJob(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="error"
                    @click="deleteDepartmentJob(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-window-item>

          <!-- Employee Titles Tab -->
          <v-window-item v-if="hasModule('employee-titles')" value="employee-titles">
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center mb-4">
                <h2 class="text-h5">المسميات الوظيفية</h2>
                <v-btn
                  color="primary"
                  prepend-icon="mdi-plus"
                  @click="openAddEmployeeTitleDialog"
                >
                  إضافة مسمى جديد
                </v-btn>
              </div>

              <v-data-table
                :headers="employeeTitleHeaders"
                :items="employeeTitles"
                :search="employeeTitleSearch"
                :loading="loading"
                color="primary"
        first-icon="mdi-chevron-left"
        last-icon="mdi-chevron-right"
        next-icon="mdi-chevron-right"
        prev-icon="mdi-chevron-left"
        show-current-page
        show-first-last-page
        show-first-page
        show-last-page
        show-next-page
        show-previous-page
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="employeeTitleSearch"
                    prepend-inner-icon="mdi-magnify"
                    label="بحث في المسميات"
                    variant="outlined"
                    density="compact"
                    class="mx-4 mt-4"
                  ></v-text-field>
                </template>

                <template v-slot:item.created_at="{ item }">
                  {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="primary"
                    @click="editEmployeeTitle(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="error"
                    @click="deleteEmployeeTitle(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-window-item>

          <!-- Template Categories Tab -->
          <v-window-item v-if="hasModule('mail-template-categories')" value="template-categories">
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center mb-4">
                <h2 class="text-h5">فئات قوالب المراسلات</h2>
                <v-btn
                  color="primary"
                  prepend-icon="mdi-plus"
                  @click="openAddTemplateCategoryDialog"
                >
                  إضافة فئة جديدة
                </v-btn>
              </div>

              <v-data-table
                :headers="templateCategoryHeaders"
                :items="templateCategories"
                :search="templateCategorySearch"
                :loading="loading"
                color="primary"
        first-icon="mdi-chevron-left"
        last-icon="mdi-chevron-right"
        next-icon="mdi-chevron-right"
        prev-icon="mdi-chevron-left"
        show-current-page
        show-first-last-page
        show-first-page
        show-last-page
        show-next-page
        show-previous-page
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="templateCategorySearch"
                    prepend-inner-icon="mdi-magnify"
                    label="بحث في فئات القوالب"
                    variant="outlined"
                    density="compact"
                    class="mx-4 mt-4"
                  ></v-text-field>
                </template>

                <template v-slot:item.created_at="{ item }">
                  {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="primary"
                    @click="editTemplateCategory(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="error"
                    @click="deleteTemplateCategory(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-window-item>

          <!-- Mail Types Tab -->
          <v-window-item v-if="hasModule('mail-types')" value="mail-types">
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center mb-4">
                <h2 class="text-h5">أنواع المراسلات</h2>
                <v-btn
                  color="primary"
                  prepend-icon="mdi-plus"
                  @click="openAddMailTypeDialog"
                >
                  إضافة نوع جديد
                </v-btn>
              </div>

              <v-data-table
                :headers="mailTypeHeaders"
                :items="mailTypes"
                :search="mailTypeSearch"
                :loading="loading"
                color="primary"
                first-icon="mdi-chevron-left"
                last-icon="mdi-chevron-right"
                next-icon="mdi-chevron-right"
                prev-icon="mdi-chevron-left"
                show-current-page
                show-first-last-page
                show-first-page
                show-last-page
                show-next-page
                show-previous-page
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="mailTypeSearch"
                    prepend-inner-icon="mdi-magnify"
                    label="بحث في أنواع المراسلات"
                    variant="outlined"
                    density="compact"
                    class="mx-4 mt-4"
                  ></v-text-field>
                </template>

                <template v-slot:item.active="{ item }">
                  <v-chip
                    :color="(item.active === 1 || item.active === true) ? 'success' : 'error'"
                    :text="(item.active === 1 || item.active === true) ? 'مفعل' : 'معطل'"
                    size="small"
                  ></v-chip>
                </template>

                <template v-slot:item.created_at="{ item }">
                  {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="primary"
                    @click="editMailType(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    color="error"
                    @click="deleteMailType(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-window-item>
        </v-window>
      </v-card>
      
      <!-- No Access Message -->
      <v-card v-else class="text-center pa-8">
        <v-icon size="64" color="grey-lighten-1" class="mb-4">mdi-lock-outline</v-icon>
        <h2 class="text-h5 mb-2">لا توجد صلاحيات للوصول</h2>
        <p class="text-body-1 text-grey mb-4">
          ليس لديك صلاحيات للوصول إلى أي من إعدادات النظام. 
          يرجى التواصل مع المسؤول لمنحك الصلاحيات المناسبة.
        </p>
        <v-btn 
          color="primary" 
          variant="outlined"
          prepend-icon="mdi-arrow-left"
          @click="$router.go(-1)"
        >
          العودة للخلف
        </v-btn>
      </v-card>
    </v-container>

    <!-- Priority Dialog -->
    <v-dialog v-model="showPriorityDialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ editingPriority ? 'تعديل الأولوية' : 'إضافة أولوية جديدة' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="priorityForm" v-model="valid" @submit.prevent="savePriority">
            <v-text-field
              v-model="priorityForm.name"
              :rules="priorityRules.name"
              label="اسم الأولوية"
              variant="outlined"
              required
              class="mb-4"
            ></v-text-field>
            
            <v-textarea
              v-model="priorityForm.desc"
              :rules="priorityRules.desc"
              label="الوصف"
              variant="outlined"
              rows="3"
              class="mb-4"
            ></v-textarea>
            
            <v-text-field
              v-model.number="priorityForm.level"
              :rules="priorityRules.level"
              label="مستوى الأولوية"
              type="number"
              min="1"
              variant="outlined"
              required
              class="mb-4"
            ></v-text-field>
            
            <v-switch
              :model-value="priorityForm.active === 1"
              @update:model-value="priorityForm.active = $event ? 1 : 0"
              label="مفعل"
              color="primary"
              class="mb-4"
            ></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="showPriorityDialog = false">إلغاء</v-btn>
          <v-btn 
            color="primary" 
            :loading="loading"
            :disabled="!valid"
            @click="savePriority"
          >
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Role Dialog -->
    <v-dialog v-model="showRoleDialog" max-width="700px">
      <v-card>
        <v-card-title>
          {{ editingRole ? 'تعديل الدور' : 'إضافة دور جديد' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="roleForm" @submit.prevent="saveRole">
            <v-text-field
              v-model="roleForm.name"
              label="اسم الدور"
              variant="outlined"
              required
              class="mb-4"
            ></v-text-field>
            
            <v-textarea
              v-model="roleForm.desc"
              label="الوصف"
              variant="outlined"
              rows="3"
              class="mb-4"
            ></v-textarea>
            
            <!-- CRUD Permissions Table -->
            <v-card variant="outlined" class="mb-4">
              <v-card-title class="text-subtitle-1 d-flex justify-space-between align-center">
                <span>الصلاحيات</span>
                <div>
                <v-btn
                    variant="text"
                  size="small"
                  color="primary"
                  @click="selectAllPermissions"
                >
                    تحديد الكل
                </v-btn>
                <v-btn
                    variant="text"
                  size="small"
                  color="error"
                  @click="clearAllPermissions"
                >
                    إلغاء الكل
                </v-btn>
                <v-chip 
                  color="primary" 
                  size="small"
                  variant="outlined"
                >
                    {{ roleForm.permissions.length }} محدد
                </v-chip>
              </div>
              </v-card-title>
              <v-card-text>
                <div v-if="backendPermissions.length === 0" class="text-center py-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <p class="mt-2">جاري تحميل الصلاحيات...</p>
              </div>

                <div v-else>
                  <!-- CRUD Permissions Table -->
                  <v-table class="elevation-1">
                    <thead>
                      <tr>
                        <th class="text-start font-weight-bold">الموديول</th>
                        <th class="text-center font-weight-bold">عرض</th>
                        <th class="text-center font-weight-bold">إضافة</th>
                        <th class="text-center font-weight-bold">تعديل</th>
                        <th class="text-center font-weight-bold">حذف</th>
                        <th class="text-center font-weight-bold">أخرى</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="resource in permissionMatrix" :key="resource.name">
                        <td class="font-weight-medium">
                          <v-chip color="primary" variant="outlined" size="small">
                            {{ " "+resource.displayName+" " }}
                        </v-chip>
                        </td>
                        <td class="text-center">
                      <v-checkbox
                            v-if="resource.permissions.index"
                            :model-value="roleForm.permissions.includes(resource.permissions.index.id)"
                            @update:model-value="toggleSinglePermission(resource.permissions.index.id, $event)"
                            hide-details
                        color="success"
                        base-color="grey-darken-1"
                        class="permission-checkbox"
                          ></v-checkbox>
                          <span v-else class="text-disabled">-</span>
                        </td>
                        <td class="text-center">
                          <v-checkbox
                            v-if="resource.permissions.store"
                            :model-value="roleForm.permissions.includes(resource.permissions.store.id)"
                            @update:model-value="toggleSinglePermission(resource.permissions.store.id, $event)"
                        hide-details
                            color="success"
                        base-color="grey-darken-1"
                        class="permission-checkbox"
                          ></v-checkbox>
                          <span v-else class="text-disabled">-</span>
                        </td>
                        <td class="text-center">
                          <v-checkbox
                            v-if="resource.permissions.update"
                            :model-value="roleForm.permissions.includes(resource.permissions.update.id)"
                            @update:model-value="toggleSinglePermission(resource.permissions.update.id, $event)"
                            hide-details
                            color="success"
                        base-color="grey-darken-1"
                        class="permission-checkbox"
                          ></v-checkbox>
                          <span v-else class="text-disabled">-</span>
                        </td>
                        <td class="text-center">
                          <v-checkbox
                            v-if="resource.permissions.destroy"
                            :model-value="roleForm.permissions.includes(resource.permissions.destroy.id)"
                            @update:model-value="toggleSinglePermission(resource.permissions.destroy.id, $event)"
                            hide-details
                            color="success"
                        base-color="grey-darken-1"
                        class="permission-checkbox"
                          ></v-checkbox>
                          <span v-else class="text-disabled">-</span>
                        </td>
                        <td class="text-center">
                          <v-menu v-if="resource.permissions.other && resource.permissions.other.length > 0">
                            <template v-slot:activator="{ props }">
                              <v-btn v-bind="props" size="small" variant="outlined">
                                {{ getSelectedOtherCount(resource.permissions.other) }}/{{ resource.permissions.other.length }}
                              </v-btn>
                            </template>
                    <v-list>
                              <v-list-item v-for="permission in resource.permissions.other" :key="permission.id">
                        <v-checkbox
                                  :model-value="roleForm.permissions.includes(permission.id)"
                                  @update:model-value="toggleSinglePermission(permission.id, $event)"
                                  :label=" ' '+permission.displayName+' '"
                          hide-details
                          color="success"
                          base-color="grey-darken-1"
                          class="permission-checkbox"
                                ></v-checkbox>
                      </v-list-item>
                    </v-list>
                          </v-menu>
                          <span v-else class="text-disabled">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                  
                  <!-- Debug Panel -->
                  <v-expansion-panels class="mt-4" v-if="$route.query.debug">
                    <v-expansion-panel>
                      <v-expansion-panel-title>
                        Debug - Selected Permission IDs ({{ roleForm.permissions.length }})
                      </v-expansion-panel-title>
                      <v-expansion-panel-text>
                        <pre class="text-caption">{{ JSON.stringify(roleForm.permissions, null, 2) }}</pre>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="showRoleDialog = false">إلغاء</v-btn>
          <v-btn color="primary" @click="saveRole">حفظ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Attachment Type Dialog -->
    <v-dialog v-model="showAttachmentDialog" max-width="600px">
      <v-card>
        <v-card-title>
          {{ editingAttachment ? 'تعديل نوع المرفق' : 'إضافة نوع مرفق جديد' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="attachmentForm" @submit.prevent="saveAttachmentType">
            <v-text-field
              v-model="attachmentForm.name"
              label="اسم النوع"
              variant="outlined"
              required
              class="mb-4"
            ></v-text-field>
            
            <v-text-field
              v-model="attachmentForm.extension"
              label="امتداد الملف"
              variant="outlined"
              required
              placeholder="PDF, DOC, JPG"
              class="mb-4"
            ></v-text-field>
            
            <v-text-field
              v-model="attachmentForm.desc"
              label="الوصف"
              variant="outlined"
              required
              placeholder="وصف نوع الملف"
              class="mb-4"
            ></v-text-field>
            
            <v-text-field
              v-model.number="attachmentForm.max_size"
              label="الحد الأقصى للحجم (بالبايت)"
              type="number"
              variant="outlined"
              required
              class="mb-4"
            ></v-text-field>
            
            <v-select
              v-model="attachmentForm.icon"
              :items="fileIcons"
              label="أيقونة النوع"
              variant="outlined"
              class="mb-4"
            ></v-select>
            
            <v-color-picker
              v-model="attachmentForm.color"
              label="لون النوع"
              class="mb-4"
            ></v-color-picker>
            
            <v-switch
              v-model="attachmentForm.active"
              label="مفعل"
              color="primary"
            ></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="showAttachmentDialog = false">إلغاء</v-btn>
          <v-btn color="primary" @click="saveAttachmentType">حفظ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Role Permissions Dialog -->
    <v-dialog v-model="showPermissionsDialog" max-width="600px">
      <v-card v-if="selectedRole">
        <v-card-title>صلاحيات الدور: {{ selectedRole.name }}</v-card-title>
        <v-card-text>
          <div v-if="getPermissionDetails(selectedRole).length === 0" class="text-center py-4">
            <v-icon size="48" color="grey">mdi-shield-off</v-icon>
            <p class="text-grey mt-2">لا توجد صلاحيات مُعيّنة لهذا الدور</p>
          </div>
          <v-list v-else>
            <v-list-item
              v-for="permissionDetail in getPermissionDetails(selectedRole)"
              :key="permissionDetail.id"
            >
              <template v-slot:prepend>
                <v-icon color="green">mdi-check-circle</v-icon>
              </template>
              <v-list-item-title>{{ permissionDetail.description }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ permissionDetail.name }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showPermissionsDialog = false">إغلاق</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Department Job Dialog -->
    <v-dialog v-model="showDepartmentJobDialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ editingDepartmentJob ? 'تعديل الوظيفة' : 'إضافة وظيفة جديدة' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="departmentJobForm" v-model="valid" @submit.prevent="saveDepartmentJob">
            <v-text-field
              v-model="departmentJobForm.name"
              label="اسم الوظيفة"
              variant="outlined"
              required
              :rules="[v => !!v || 'اسم الوظيفة مطلوب']"
              class="mb-4"
              placeholder="مطور برمجيات، محاسب، محامي..."
            ></v-text-field>
            
            <!-- <v-select
              v-model="departmentJobForm.department_id"
              :items="departments"
              item-title="name"
              item-value="id"
              label="القسم"
              variant="outlined"
              required
              :rules="[v => !!v || 'القسم مطلوب']"
              class="mb-4"
              placeholder="اختر القسم..."
            ></v-select> -->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeDepartmentJobDialog">إلغاء</v-btn>
          <v-btn 
            color="primary" 
            :loading="loading"
            :disabled="!valid"
            @click="saveDepartmentJob"
          >
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Employee Title Dialog -->
    <v-dialog v-model="showEmployeeTitleDialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ editingEmployeeTitle ? 'تعديل المسمى الوظيفي' : 'إضافة مسمى وظيفي جديد' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="employeeTitleForm" v-model="valid" @submit.prevent="saveEmployeeTitle">
            <v-text-field
              v-model="employeeTitleForm.name"
              label="المسمى الوظيفي"
              variant="outlined"
              required
              :rules="[v => !!v || 'المسمى الوظيفي مطلوب']"
              class="mb-4"
              placeholder="د. ، م. ، أ.د. ، أستاذ..."
            ></v-text-field>
            
            <v-text-field
              v-model="employeeTitleForm.short_name"
              label="الاختصار"
              variant="outlined"
              required
              :rules="[v => !!v || 'الاختصار مطلوب']"
              class="mb-4"
              placeholder="Dr, Eng, Prof..."
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeEmployeeTitleDialog">إلغاء</v-btn>
          <v-btn 
            color="primary" 
            :loading="loading"
            :disabled="!valid"
            @click="saveEmployeeTitle"
          >
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Template Category Dialog -->
    <v-dialog v-model="showTemplateCategoryDialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ editingTemplateCategory ? 'تعديل فئة القالب' : 'إضافة فئة قالب جديدة' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="templateCategoryForm" v-model="valid" @submit.prevent="saveTemplateCategory">
            <v-text-field
              v-model="templateCategoryForm.name"
              label="اسم الفئة"
              variant="outlined"
              required
              :rules="[v => !!v || 'اسم الفئة مطلوب']"
              class="mb-4"
              placeholder="رسائل إدارية، إشعارات، تقارير..."
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeTemplateCategoryDialog">إلغاء</v-btn>
          <v-btn 
            color="primary" 
            :loading="loading"
            :disabled="!valid"
            @click="saveTemplateCategory"
          >
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Mail Type Dialog -->
    <v-dialog v-model="showMailTypeDialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ editingMailType ? 'تعديل نوع المراسل' : 'إضافة نوع مراسل جديد' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="mailTypeForm" v-model="valid" @submit.prevent="saveMailType">
            <v-text-field
              v-model="mailTypeForm.name"
              label="اسم النوع"
              variant="outlined"
              required
              :rules="[v => !!v || 'اسم النوع مطلوب']"
              class="mb-4"
              placeholder="عام، إداري، مالي..."
            ></v-text-field>
            
            <v-textarea
              v-model="mailTypeForm.desc"
              label="الوصف"
              variant="outlined"
              rows="3"
              class="mb-4"
            ></v-textarea>
            
            <v-switch
              :model-value="mailTypeForm.active === 1"
              @update:model-value="mailTypeForm.active = $event ? 1 : 0"
              label="مفعل"
              color="primary"
              class="mb-4"
            ></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeMailTypeDialog">إلغاء</v-btn>
          <v-btn 
            color="primary" 
            :loading="loading"
            :disabled="!valid"
            @click="saveMailType"
          >
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>تأكيد الحذف</v-card-title>
        <v-card-text>
          {{ getDeleteMessage() }}
          <br>
          <small class="text-grey">لا يمكن التراجع عن هذا الإجراء.</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            variant="text"
            @click="confirmDelete"
          >
            حذف
          </v-btn>
          <v-btn
            color="primary"
            variant="text"
            @click="deleteDialog = false"
          >
            إلغاء
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mailPriorityService from '@/services/mailPriorityService'
import roleService from '@/services/roleService'
import employeeTitleService from '@/services/employeeTitleService'
import departmentJobService from '@/services/departmentJobService'
import departmentService from '@/services/departmentService'
import fileTypeService from '@/services/fileTypeService'
import mailTemplateCategoryService from '@/services/mailTemplateCategoryService'
import mailTypeService from '@/services/mailTypeService'
import { formValidation } from '@/assets/validations'
import { PERMISSIONS, hasModule } from '@/utils/permissions'

export default {
  name: 'SettingsView',
  computed: {
    hasAnySettingsAccess() {
      // Debug: Log available modules
      //console.log('Available modules from store:', this.$store.getters.availableModules)
      //console.log('All modules object:', this.$store.getters.modules)
      
      // Check if user has access to any settings modules
      const settingsModules = [
        'mail-priorities',
        'roles', 
        'file-types',
        'department-jobs',
        'employee-titles',
        'mail-template-categories',
        'mail-types'
      ]
      
      //console.log('Checking settings modules:', settingsModules)
      const hasAccess = settingsModules.some(module => {
        const access = this.hasModule(module)
        //console.log(`Module ${module}: ${access}`)
        return access
      })
      
      //console.log('Has any settings access:', hasAccess)
      return hasAccess
    },
    PERMISSIONS() {
      return PERMISSIONS
    },
    availableTabs() {
      // Return list of available tabs based on permissions
      const tabs = []
      //console.log('Checking individual tab permissions:')
      
      if (this.hasModule('mail-priorities')) {
        tabs.push('priorities')
        //console.log('✓ Added priorities tab')
      } else {
        //console.log('✗ No access to mail-priorities')
      }
      
      if (this.hasModule('roles')) {
        tabs.push('roles')
        //console.log('✓ Added roles tab')
      } else {
        //console.log('✗ No access to roles')
      }
      
      if (this.hasModule('file-types')) {
        tabs.push('attachments')
        //console.log('✓ Added attachments tab')
      } else {
        //console.log('✗ No access to file-types')
      }
      
      if (this.hasModule('department-jobs')) {
        tabs.push('department-jobs')
        //console.log('✓ Added department-jobs tab')
      } else {
        //console.log('✗ No access to department-jobs')
      }
      
      if (this.hasModule('employee-titles')) {
        tabs.push('employee-titles')
        //console.log('✓ Added employee-titles tab')
      } else {
        //console.log('✗ No access to employee-titles')
      }
      
      if (this.hasModule('mail-template-categories')) {
        tabs.push('template-categories')
        //console.log('✓ Added template-categories tab')
      } else {
        //console.log('✗ No access to mail-template-categories')
      }
      
      if (this.hasModule('mail-types')) {
        tabs.push('mail-types')
        //console.log('✓ Added mail-types tab')
      } else {
        //console.log('✗ No access to mail-types')
      }
      
      //console.log('Available tabs:', tabs)
      return tabs
    }
  },
  data() {
    return {
      activeTab: 'priorities',
      loading: false,
      valid: false,
      
      // Priority Management
      prioritySearch: '',
      showPriorityDialog: false,
      editingPriority: null,
      priorityForm: {
        name: '',
        desc: '',
        level: 1,
        active: 1
      },
      priorityHeaders: [
        { title: 'الاسم', key: 'name' },
        { title: 'الوصف', key: 'desc' },
        { title: 'المستوى', key: 'level' },
        { title: 'الحالة', key: 'active' },
        { title: 'تاريخ الإنشاء', key: 'created_at' },
        { title: 'الإجراءات', key: 'actions', sortable: false }
      ],
      priorities: [],
      
      // Validation rules
      priorityRules: formValidation.getMailPriorityFormRules(),

      // Role Management
      roleSearch: '',
      showRoleDialog: false,
      editingRole: null,
      
      // Delete Confirmation Dialog
      deleteDialog: false,
      itemToDelete: null,
      deleteType: '', // 'priority', 'role', 'attachment', 'departmentJob', 'employeeTitle', 'templateCategory', 'mailType'
      showPermissionsDialog: false,
      selectedRole: null,
      roleForm: {
        name: '',
        desc: '',
        permissions: []
      },
      roleHeaders: [
        { title: 'اسم الدور', key: 'name' },
        { title: 'الوصف', key: 'desc' },
        { title: 'الصلاحيات', key: 'permissions' },
        { title: 'تاريخ الإنشاء', key: 'created_at' },
        { title: 'الإجراءات', key: 'actions', sortable: false }
      ],
      roles: [],
      
      // Backend permissions and categories
      backendPermissions: [], // From API
      permissionCategories: [], // Will be organized from backend data
      permissionMatrix: [], // CRUD permissions matrix
      
      // Static categories for UI organization (can be dynamic later)
      uiCategories: [
        {
          id: 'user_management',
          name: 'إدارة المستخدمين',
          icon: 'mdi-account-group',
          prefix: 'admin.users'
        },
        {
          id: 'role_management',
          name: 'إدارة الأدوار',
          icon: 'mdi-shield-account',
          prefix: 'admin.roles'
        },
        {
          id: 'department_management',
          name: 'إدارة الأقسام',
          icon: 'mdi-office-building',
          prefix: 'admin.departments'
        },
        {
          id: 'mail_management',
          name: 'إدارة المراسلات',
          icon: 'mdi-email',
          prefix: 'admin.marginalizations'
        },
        {
          id: 'priority_management',
          name: 'إدارة الأولويات',
          icon: 'mdi-flag',
          prefix: 'admin.mail-priorities'
        },
        {
          id: 'settings_management',
          name: 'إدارة الإعدادات',
          icon: 'mdi-cog',
          prefix: 'admin.settings'
        },
        {
          id: 'employee_titles',
          name: 'المسميات الوظيفية',
          icon: 'mdi-badge-account',
          prefix: 'admin.employee-titles'
        },
        {
          id: 'department_jobs',
          name: 'وظائف الأقسام',
          icon: 'mdi-briefcase',
          prefix: 'admin.department-jobs'
        },
        {
          id: 'file_types',
          name: 'أنواع الملفات',
          icon: 'mdi-file',
          prefix: 'admin.file-types'
        },
        {
          id: 'user_folders',
          name: 'مجلدات المستخدمين',
          icon: 'mdi-folder',
          prefix: 'admin.user-folders'
        },
        {
          id: 'system_monitoring',
          name: 'مراقبة النظام',
          icon: 'mdi-monitor-dashboard',
          prefix: 'admin.activity-logs'
        }
      ],

      // Attachment Types
      attachmentSearch: '',
      showAttachmentDialog: false,
      editingAttachment: null,
      attachmentForm: {
        name: '',
        extension: '',
        max_size: 5242880, // 5MB default
        icon: 'mdi-file',
        color: '#1976D2',
        desc: '',
        active: true
      },
      attachmentHeaders: [
        { title: 'الأيقونة', key: 'icon' },
        { title: 'اسم النوع', key: 'name' },
        { title: 'الامتداد', key: 'extension' },
        { title: 'الوصف', key: 'desc' },
        { title: 'الحد الأقصى', key: 'max_size' },
        { title: 'مفعل', key: 'active' },
        { title: 'الإجراءات', key: 'actions', sortable: false }
      ],
      attachmentTypes: [],
      fileIcons: [
        { title: 'ملف عام', value: 'mdi-file' },
        { title: 'PDF', value: 'mdi-file-pdf-box' },
        { title: 'Word', value: 'mdi-file-word-box' },
        { title: 'Excel', value: 'mdi-file-excel-box' },
        { title: 'PowerPoint', value: 'mdi-file-powerpoint-box' },
        { title: 'صورة', value: 'mdi-file-image-box' },
        { title: 'فيديو', value: 'mdi-file-video-box' },
        { title: 'صوت', value: 'mdi-file-music-box' },
        { title: 'أرشيف', value: 'mdi-folder-zip' }
      ],

      // Department Jobs Management
      departmentJobSearch: '',
      showDepartmentJobDialog: false,
      editingDepartmentJob: null,
      departmentJobForm: {
        name: '',
        department_id: ''
      },
      departmentJobHeaders: [
        { title: 'اسم الوظيفة', key: 'name' },
   
        { title: 'تاريخ الإنشاء', key: 'created_at' },
        { title: 'الإجراءات', key: 'actions', sortable: false }
      ],
      departmentJobs: [],
      departments: [], // For department dropdown

      // Employee Titles Management
      employeeTitleSearch: '',
      showEmployeeTitleDialog: false,
      editingEmployeeTitle: null,
      employeeTitleForm: {
        name: '',
        short_name: ''
      },
      employeeTitleHeaders: [
        { title: 'المسمى الوظيفي', key: 'name' },
        { title: 'الاختصار', key: 'short_name' },
        { title: 'تاريخ الإنشاء', key: 'created_at' },
        { title: 'الإجراءات', key: 'actions', sortable: false }
      ],
      employeeTitles: [],

      // Template Categories Management
      templateCategorySearch: '',
      showTemplateCategoryDialog: false,
      editingTemplateCategory: null,
      templateCategoryForm: {
        name: ''
      },
      templateCategoryHeaders: [
        { title: 'اسم الفئة', key: 'name' },
        { title: 'تاريخ الإنشاء', key: 'created_at' },
        { title: 'الإجراءات', key: 'actions', sortable: false }
      ],
      templateCategories: [],

      // Mail Types Management
      mailTypeSearch: '',
      showMailTypeDialog: false,
      editingMailType: null,
      mailTypeForm: {
        name: '',
        desc: '',
        active: 1
      },
      mailTypeHeaders: [
        { title: 'الاسم', key: 'name' },
        { title: 'الوصف', key: 'desc' },
        { title: 'الحالة', key: 'active' },
        { title: 'تاريخ الإنشاء', key: 'created_at' },
        { title: 'الإجراءات', key: 'actions', sortable: false }
      ],
      mailTypes: []
    }
  },

 

  async mounted() {
    // Set the first available tab based on permissions
    if (this.availableTabs.length > 0) {
      this.activeTab = this.availableTabs[0]
    }
    
    await this.loadPriorities()
    await this.loadPermissions()  // Load permissions first
    await this.loadRoles()        // Then load roles so they can map permission names
    await this.loadFileTypes()
    await this.loadDepartments()
    await this.loadDepartmentJobs()
    await this.loadEmployeeTitles()
    await this.loadTemplateCategories()
    await this.loadMailTypes()
  },

  methods: {
    // Permission checking method
    hasModule(moduleName) {
      return hasModule(moduleName)
    },
    
    // Priority Management Methods
    async loadPriorities() {
      this.loading = true
      try {
        const response = await mailPriorityService.getMailPriorities()
        // Handle paginated response - extract data array
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.priorities = response.data.data
        } else if (response.data && Array.isArray(response.data)) {
          this.priorities = response.data
        } else {
          this.priorities = []
        }
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          type: 'error',
          message: error.message || 'فشل في جلب الأولويات'
        })
      } finally {
        this.loading = false
      }
    },

    openAddPriorityDialog() {
      this.editingPriority = null
      this.priorityForm = {
        name: '',
        desc: '',
        level: 1,
        active: 1
      }
      this.showPriorityDialog = true
    },

    editPriority(item) {
      this.editingPriority = item
      this.priorityForm = {
        name: item.name,
        desc: item.desc,
        level: item.level,
        active: item.active ? 1 : 0
      }
      this.showPriorityDialog = true
    },

    deletePriority(item) {
      this.itemToDelete = item;
      this.deleteType = 'priority';
      this.deleteDialog = true;
    },

    async savePriority() {
      try {
        // Prepare data according to API specification
        const apiData = {
          name: this.priorityForm.name,
          desc: this.priorityForm.desc,
          level: this.priorityForm.level,
          active: this.priorityForm.active
        }
        
        if (this.editingPriority) {
          await mailPriorityService.updateMailPriority(this.editingPriority.id, apiData)
        } else {
          await mailPriorityService.createMailPriority(apiData)
        }
        
        await this.loadPriorities()
        this.showPriorityDialog = false
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: this.editingPriority ? 'تم تحديث الأولوية بنجاح' : 'تم إضافة الأولوية بنجاح'
        })
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في حفظ الأولوية'
        })
      }
    },

    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString('ar-LY', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    getDepartmentName(departmentId) {
      if (!departmentId) return 'غير محدد';
      const department = this.departments.find(dept => dept.id === departmentId);
      return department ? department.name : 'غير معروف';
    },

    // Role Management Methods
    async loadRoles() {
      this.loading = true
      try {
        const response = await roleService.getRoles()
        // Handle paginated response - extract data array
        let rolesData = []
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          rolesData = response.data.data
        } else if (response.data && Array.isArray(response.data)) {
          rolesData = response.data
        }
        
        // Convert permission IDs to names for display
        this.roles = rolesData.map(role => ({
          ...role,
          permissionNames: this.mapPermissionIdsToNames(role.permissions || [])
        }))
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          type: 'error',
          message: error.message || 'فشل في جلب الأدوار'
        })
      } finally {
        this.loading = false
      }
    },

    mapPermissionIdsToNames(permissionIds) {
      if (!Array.isArray(permissionIds) || !Array.isArray(this.backendPermissions)) {
        //console.log('mapPermissionIdsToNames: Invalid input', { 
          //permissionIds, 
          //backendPermissions: this.backendPermissions 
        //})
        return []
      }
      
      //console.log('Mapping permission IDs:', permissionIds)
      //console.log('Available permissions:', this.backendPermissions.length)
      
      return permissionIds.map(id => {
        const permission = this.backendPermissions.find(p => p.id === id)
        const result = permission ? permission.name : `Unknown Permission (${id})`
        //console.log(`Permission ID ${id} -> ${result}`)
        return result
      }).filter(Boolean)
    },

    async loadPermissions() {
      try {
        const response = await roleService.getPermissions()
        // Handle paginated response - extract data array
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.backendPermissions = response.data.data
        } else if (response.data && Array.isArray(response.data)) {
          this.backendPermissions = response.data
        } else {
          this.backendPermissions = []
        }
        //console.log('Loaded permissions:', this.backendPermissions);
        this.organizePermissions()
        
        // Re-map role permissions if roles are already loaded
        if (this.roles.length > 0) {
          this.roles = this.roles.map(role => ({
            ...role,
            permissionNames: this.mapPermissionIdsToNames(role.permissions || [])
          }))
        }
      } catch (error) {
        console.error('Failed to load permissions:', error);
        this.$store.dispatch('alerts/showAlert', {
          type: 'error',
          message: error.message || 'فشل في جلب الصلاحيات'
        })
      }
    },

    organizePermissions() {
  const resources = {}

  this.backendPermissions.forEach(permission => {
    const parts = permission.name.split('.')
    if (parts.length < 3) return

    const module = parts[1] // always main module
    const lastPart = parts[parts.length - 1] // could be CRUD or custom
    const middleParts = parts.slice(2, -1) // submodules if any

    // Full module key (main + submodules if exist)
    const moduleKey = middleParts.length > 0 ? `${module}.${middleParts.join('.')}` : module

    // Initialize if not exists
    if (!resources[moduleKey]) {
      resources[moduleKey] = {
        name: moduleKey,
        displayName: this.getModuleDisplayName(moduleKey),
        permissions: {
          index: null,
          store: null,
          update: null,
          destroy: null,
          other: []
        }
      }
    }

    // Determine CRUD vs other
    if (['index', 'store', 'update', 'destroy'].includes(lastPart)) {
      const displayMap = { index: 'عرض', store: 'إضافة', update: 'تعديل', destroy: 'حذف' }
      resources[moduleKey].permissions[lastPart] = {
        id: permission.id,
        name: permission.name,
        displayName: displayMap[lastPart]
      }
    } else {
      resources[moduleKey].permissions.other.push({
        id: permission.id,
        name: permission.name,
        displayName: this.getActionDisplayName(lastPart)
      })
    }
  })

  this.permissionMatrix = Object.values(resources).sort((a, b) =>
    a.displayName.localeCompare(b.displayName, 'ar')
  )

  //console.log('Permission Matrix:', this.permissionMatrix)
}
,

    getModuleDisplayName(module) {
  const moduleMap = {
    'users': 'إدارة المستخدمين',
    'roles': 'إدارة الأدوار',
    'departments': 'إدارة الأقسام',
    'marginalizations': 'إدارة التهميشات',
    'mail-priorities': 'أولويات المراسلات',
    'settings': 'إعدادات النظام',
    'employee-titles': 'المسميات الوظيفية',
    'department-jobs': 'وظائف الأقسام',
    'file-types': 'أنواع الملفات',
    'user-folders': 'مجلدات المستخدمين',
    'activity-logs': 'سجلات النشاط',
    'login-logs-users': 'سجلات تسجيل دخول المستخدمين',
    'mail-marginalizations': 'تهميشات المراسلات',
    'mail-template-categories': 'تصنيفات قوالب المراسلات',
    'mail-templates': 'قوالب المراسلات',
    'mails': 'المراسلات',
    'users.departments': 'اقسام المستخدمين',
    'archive-mails': 'الأرشيف',
    'mail-types': 'أنواع المراسلات',
    'mail-attachments': 'مرفقات المراسلات',
  }
  return moduleMap[module] || module
},

getActionDisplayName(action) {
  const actionMap = {
    'show': 'تفاصيل',
    'permissions': 'إدارة صلاحيات',
    'export': 'تصدير',
    'import': 'استيراد',
    'delete-draft': 'حذف المسودة',
    'mark-as-printed': 'وضع علامة كمطبوع',
    'history': 'تتبع المراسلات',
    'move': 'نقل',
    'send-draft': 'إرسال المسودة',
    'toggle-read': 'تبديل حالة القراءة',
    'toggle-star': 'تبديل حالة النجمة',
    'update-draft': 'تحديث المسودة',
    'store-draft': 'إضافة المسودة',
    'store-forward': 'إرسال مباشر',
    'store-reply': 'إرسال رد',
  }
  return actionMap[action] || action
},

    openAddRoleDialog() {
      this.resetRoleForm()
      this.showRoleDialog = true
    },

    editRole(item) {
      this.editingRole = item
      this.roleForm = {
        name: item.name,
        desc: item.desc || '',
        permissions: [...item.permissions] // Copy permission IDs
      }
      this.showRoleDialog = true
    },

    async saveRole() {
      try {
        const roleData = {
          name: this.roleForm.name,
          desc: this.roleForm.desc,
          permissions: this.roleForm.permissions
        }

        if (this.editingRole) {
          await roleService.updateRole(this.editingRole.id, roleData)
        } else {
          await roleService.createRole(roleData)
        }
        
        await this.loadRoles()
        this.showRoleDialog = false
        this.resetRoleForm()
        this.$store.dispatch('alerts/showAlert', {
          type: 'success',
          message: this.editingRole ? 'تم تحديث الدور بنجاح' : 'تم إضافة الدور بنجاح'
        })
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          type: 'error',
          message: error.message || 'فشل في حفظ الدور'
        })
      }
    },

    resetRoleForm() {
      this.editingRole = null
      this.roleForm = {
        name: '',
        desc: '',
        permissions: []
      }
    },

    viewRolePermissions(item) {
      this.selectedRole = item
      this.showPermissionsDialog = true
    },

    handlePermissionChange(category, perm) {
      // Toggle individual permission
      const permId = perm.id
      const index = this.roleForm.permissions.indexOf(permId)
      
      if (index > -1) {
        this.roleForm.permissions.splice(index, 1)
      } else {
        this.roleForm.permissions.push(permId)
      }
    },

    selectAllPermissions() {
      // Get all permission IDs from the matrix
      const allPermissionIds = []
      this.permissionMatrix.forEach(resource => {
        // Add CRUD permissions
        if (resource.permissions.index) allPermissionIds.push(resource.permissions.index.id)
        if (resource.permissions.store) allPermissionIds.push(resource.permissions.store.id)
        if (resource.permissions.update) allPermissionIds.push(resource.permissions.update.id)
        if (resource.permissions.destroy) allPermissionIds.push(resource.permissions.destroy.id)
        // Add other permissions
        resource.permissions.other.forEach(permission => {
          allPermissionIds.push(permission.id)
        })
      })
      this.roleForm.permissions = [...allPermissionIds];
      //console.log('Selected all permissions:', this.roleForm.permissions);
    },

    clearAllPermissions() {
      this.roleForm.permissions = [];
      //console.log('Cleared all permissions');
    },

    toggleSinglePermission(id, checked) {
      if (checked) {
          if (!this.roleForm.permissions.includes(id)) {
          this.roleForm.permissions.push(id);
        }
      } else {
        this.roleForm.permissions = this.roleForm.permissions.filter(p => p !== id);
      }
      //console.log('Permission toggled:', id, checked, 'Current:', this.roleForm.permissions);
    },

    getSelectedOtherCount(otherPermissions) {
      return otherPermissions.filter(p => this.roleForm.permissions.includes(p.id)).length;
    },

    getPermissionDisplayName(permissionName) {
      const parts = permissionName.split('.')
      const action = parts[parts.length - 1]
      
      const actionMap = {
        'index': 'عرض',
        'store': 'إضافة',
        'update': 'تعديل',
        'destroy': 'حذف',
        'show': 'تفاصيل',
        'permissions': 'الصلاحيات'
      }
      
      return actionMap[action] || action
    },

    getPermissionDescription(permissionName) {
      const parts = permissionName.split('.')
      const resource = parts[1]
      const action = parts[parts.length - 1]
      
      const resourceMap = {
        'users': 'المستخدمين',
        'roles': 'الأدوار',
        'departments': 'الأقسام',
        'marginalizations': 'التهميشات',
        'mail-priorities': 'أولويات المراسلات',
        'archive-mails': 'الأرشيف',

        'settings': 'الإعدادات',
        'employee-titles': 'المسميات الوظيفية',
        'department-jobs': 'وظائف الأقسام',
        'file-types': 'أنواع الملفات',
        'user-folders': 'مجلدات المستخدمين',
        'activity-logs': 'سجلات النشاط'
      }
      
      const actionMap = {
        'index': 'عرض',
        'store': 'إضافة',
        'update': 'تعديل',
        'destroy': 'حذف',
        'show': 'تفاصيل',
        'permissions': 'إدارة صلاحيات'
      }
      
      const resourceName = resourceMap[resource] || resource
      const actionName = actionMap[action] || action
      
      return `${actionName} ${resourceName}`
    },

    getPermissionDetails(role) {
      if (!role || !role.permissions || !Array.isArray(role.permissions)) {
        return []
      }
      
      // Safety check for backend permissions
      if (!this.backendPermissions || !Array.isArray(this.backendPermissions)) {
        console.warn('Backend permissions not loaded yet')
        return []
      }
      
      const permissionDetails = []
      
      // Iterate through the role's permissions (which could be IDs or objects)
      role.permissions.forEach(permission => {
        // Handle different permission data structures
        if (typeof permission === 'object' && permission.id && permission.name) {
          // Permission is already an object with details
          permissionDetails.push({
            id: permission.id,
            name: permission.name,
            description: this.getPermissionDescription(permission.name)
          })
        } else {
          // Permission is an ID - find the permission object
          const permissionId = typeof permission === 'object' ? permission.id : permission
          const permissionObj = this.backendPermissions.find(p => p.id === permissionId)
          
          if (permissionObj) {
            permissionDetails.push({
              id: permissionObj.id,
              name: permissionObj.name,
              description: this.getPermissionDescription(permissionObj.name)
            })
          } else {
            // Fallback for unknown permissions
            permissionDetails.push({
              id: permissionId,
              name: `صلاحية غير معروفة ${permissionId}`,
              description: `صلاحية غير معروفة (ID: ${permissionId})`
            })
          }
        }
      })
      
      // Sort by description for better display
      return permissionDetails.sort((a, b) => a.description.localeCompare(b.description, 'ar'))
    },

    // File Types Methods
    async loadFileTypes() {
      this.loading = true;
      try {
        const response = await fileTypeService.getFileTypes();
        // Handle the nested paginated response structure
        if (response.data && response.data.data && response.data.data.data && Array.isArray(response.data.data.data)) {
          this.attachmentTypes = response.data.data.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.attachmentTypes = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          this.attachmentTypes = response.data;
        } else {
          this.attachmentTypes = [];
        }
        //console.log('Loaded file types:', this.attachmentTypes);
      } catch (error) {
        console.error('Failed to load file types:', error);
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في جلب أنواع الملفات'
        });
      } finally {
        this.loading = false;
      }
    },

    openAddAttachmentDialog() {
      this.editingAttachment = null;
      this.attachmentForm = {
        name: '',
        extension: '',
        max_size: 5242880,
        icon: 'mdi-file',
        color: '#1976D2',
        desc: '',
        active: true
      };
      this.showAttachmentDialog = true;
    },

    editAttachmentType(item) {
      this.editingAttachment = item;
      this.attachmentForm = {
        name: item.name,
        extension: item.extension,
        max_size: item.max_size,
        icon: item.icon,
        color: item.color,
        desc: item.desc,
        active: item.active
      };
      this.showAttachmentDialog = true;
    },

    deleteAttachmentType(item) {
      this.itemToDelete = item;
      this.deleteType = 'attachment';
      this.deleteDialog = true;
    },

    async saveAttachmentType() {
      try {
        // Prepare data according to API specification
        const fileTypeData = {
          name: this.attachmentForm.name,
          extension: this.attachmentForm.extension,
          max_size: this.attachmentForm.max_size,
          icon: this.attachmentForm.icon,
          color: this.attachmentForm.color,
          desc: this.attachmentForm.desc,
          active: this.attachmentForm.active ? 1 : 0
        };

      if (this.editingAttachment) {
          await fileTypeService.updateFileType(this.editingAttachment.id, fileTypeData);
      } else {
          await fileTypeService.createFileType(fileTypeData);
        }

        await this.loadFileTypes();
      this.showAttachmentDialog = false;
      this.resetAttachmentForm();
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: this.editingAttachment ? 'تم تحديث نوع المرفق بنجاح' : 'تم إضافة نوع المرفق بنجاح'
        });
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في حفظ نوع المرفق'
        });
      }
    },

    resetAttachmentForm() {
      this.editingAttachment = null;
      this.attachmentForm = {
        name: '',
        extension: '',
        max_size: 5242880,
        icon: 'mdi-file',
        color: '#1976D2',
        desc: '',
        active: true
      };
    },



    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // Department Jobs Methods
    async loadDepartments() {
      try {
        const response = await departmentService.getDepartments();
        // Handle paginated response - extract data array
        if (response.data && response.data.data && response.data.data.data && Array.isArray(response.data.data.data)) {
          this.departments = response.data.data.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.departments = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          this.departments = response.data;
        } else {
          this.departments = [];
        }
        //console.log('Loaded departments:', this.departments);
      } catch (error) {
        console.error('Failed to load departments:', error);
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في جلب الأقسام'
        });
      }
    },

    async loadDepartmentJobs() {
      this.loading = true;
      try {
        const response = await departmentJobService.getDepartmentJobs();
        // Handle the nested paginated response structure
        if (response.data && response.data.data && response.data.data.data && Array.isArray(response.data.data.data)) {
          this.departmentJobs = response.data.data.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.departmentJobs = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          this.departmentJobs = response.data;
        } else {
          this.departmentJobs = [];
        }
        //console.log('Loaded department jobs:', this.departmentJobs);
      } catch (error) {
        console.error('Failed to load department jobs:', error);
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في جلب وظائف الأقسام'
        });
      } finally {
        this.loading = false;
      }
    },

    openAddDepartmentJobDialog() {
      this.editingDepartmentJob = null;
      this.departmentJobForm = {
        name: '',
       
      };
      this.showDepartmentJobDialog = true;
    },

    editDepartmentJob(item) {
      this.editingDepartmentJob = item;
      this.departmentJobForm = {
        name: item.name,
       
      };
      this.showDepartmentJobDialog = true;
    },

    deleteDepartmentJob(item) {
      this.itemToDelete = item;
      this.deleteType = 'departmentJob';
      this.deleteDialog = true;
    },

    async saveDepartmentJob() {
      try {
        // Prepare data according to API specification
        const jobData = {
          name: this.departmentJobForm.name,
         
        };

        if (this.editingDepartmentJob) {
          await departmentJobService.updateDepartmentJob(this.editingDepartmentJob.id, jobData);
        } else {
          await departmentJobService.createDepartmentJob(jobData);
        }

        await this.loadDepartmentJobs();
        this.closeDepartmentJobDialog();
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: this.editingDepartmentJob ? 'تم تحديث الوظيفة بنجاح' : 'تم إضافة الوظيفة بنجاح'
        });
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في حفظ الوظيفة'
        });
      }
    },

    closeDepartmentJobDialog() {
      this.showDepartmentJobDialog = false;
    },

    // Employee Titles Methods
    async loadEmployeeTitles() {
      this.loading = true;
      try {
        const response = await employeeTitleService.getEmployeeTitles();
        // Handle the nested paginated response structure
        if (response.data && response.data.data && response.data.data.data && Array.isArray(response.data.data.data)) {
          this.employeeTitles = response.data.data.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.employeeTitles = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          this.employeeTitles = response.data;
        } else {
          this.employeeTitles = [];
        }
        //console.log('Loaded employee titles:', this.employeeTitles);
      } catch (error) {
        console.error('Failed to load employee titles:', error);
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في جلب المسميات الوظيفية'
        });
      } finally {
        this.loading = false;
      }
    },

    openAddEmployeeTitleDialog() {
      this.editingEmployeeTitle = null;
      this.employeeTitleForm = {
        name: '',
        short_name: ''
      };
      this.showEmployeeTitleDialog = true;
    },

    editEmployeeTitle(item) {
      this.editingEmployeeTitle = item;
      this.employeeTitleForm = {
        name: item.name,
        short_name: item.short_name
      };
      this.showEmployeeTitleDialog = true;
    },

    deleteEmployeeTitle(item) {
      this.itemToDelete = item;
      this.deleteType = 'employeeTitle';
      this.deleteDialog = true;
    },

    async saveEmployeeTitle() {
      try {
        // Prepare data according to API specification
        const titleData = {
          name: this.employeeTitleForm.name,
          short_name: this.employeeTitleForm.short_name
        };

        if (this.editingEmployeeTitle) {
          await employeeTitleService.updateEmployeeTitle(this.editingEmployeeTitle.id, titleData);
        } else {
          await employeeTitleService.createEmployeeTitle(titleData);
        }

        await this.loadEmployeeTitles();
        this.closeEmployeeTitleDialog();
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: this.editingEmployeeTitle ? 'تم تحديث المسمى الوظيفي بنجاح' : 'تم إضافة المسمى الوظيفي بنجاح'
        });
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في حفظ المسمى الوظيفي'
        });
      }
    },

    closeEmployeeTitleDialog() {
      this.showEmployeeTitleDialog = false;
    },

    // Template Categories Methods
    async loadTemplateCategories() {
      this.loading = true;
      try {
        const response = await mailTemplateCategoryService.getMailTemplateCategories();
        // Handle the nested paginated response structure
        if (response.data && response.data.data && response.data.data.data && Array.isArray(response.data.data.data)) {
          this.templateCategories = response.data.data.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.templateCategories = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          this.templateCategories = response.data;
        } else {
          this.templateCategories = [];
        }
        //console.log('Loaded template categories:', this.templateCategories);
      } catch (error) {
        console.error('Failed to load template categories:', error);
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في جلب فئات القوالب'
        });
      } finally {
        this.loading = false;
      }
    },

    openAddTemplateCategoryDialog() {
      this.editingTemplateCategory = null;
      this.templateCategoryForm = {
        name: ''
      };
      this.showTemplateCategoryDialog = true;
    },

    editTemplateCategory(item) {
      this.editingTemplateCategory = item;
      this.templateCategoryForm = {
        name: item.name
      };
      this.showTemplateCategoryDialog = true;
    },

    deleteTemplateCategory(item) {
      this.itemToDelete = item;
      this.deleteType = 'templateCategory';
      this.deleteDialog = true;
    },

    async confirmDelete() {
      try {
        const item = this.itemToDelete;
        let service, loadMethod, successMessage;

        switch (this.deleteType) {
          case 'priority':
            service = mailPriorityService;
            loadMethod = this.loadPriorities;
            successMessage = 'تم حذف الأولوية بنجاح';
            await service.deleteMailPriority(item.id);
            break;
          case 'attachment':
            service = fileTypeService;
            loadMethod = this.loadFileTypes;
            successMessage = 'تم حذف نوع المرفق بنجاح';
            await service.deleteFileType(item.id);
            break;
          case 'departmentJob':
            service = departmentJobService;
            loadMethod = this.loadDepartmentJobs;
            successMessage = 'تم حذف الوظيفة بنجاح';
            await service.deleteDepartmentJob(item.id);
            break;
          case 'employeeTitle':
            service = employeeTitleService;
            loadMethod = this.loadEmployeeTitles;
            successMessage = 'تم حذف المسمى الوظيفي بنجاح';
            await service.deleteEmployeeTitle(item.id);
            break;
          case 'templateCategory':
            service = mailTemplateCategoryService;
            loadMethod = this.loadTemplateCategories;
            successMessage = 'تم حذف فئة القالب بنجاح';
            await service.deleteMailTemplateCategory(item.id);
            break;
          case 'mailType':
            service = mailTypeService;
            loadMethod = this.loadMailTypes;
            successMessage = 'تم حذف نوع المراسل بنجاح';
            await service.deleteMailType(item.id);
            break;
          default:
            throw new Error('نوع حذف غير معروف');
        }

        await loadMethod();
        this.deleteDialog = false;
        this.itemToDelete = null;
        this.deleteType = '';

        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: successMessage
        });
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'حدث خطأ أثناء عملية الحذف'
        });
      }
    },

    getDeleteMessage() {
      if (!this.itemToDelete) return '';
      
      const typeMessages = {
        priority: 'الأولوية',
        attachment: 'نوع المرفق',
        departmentJob: 'الوظيفة',
        employeeTitle: 'المسمى الوظيفي',
        templateCategory: 'فئة القالب',
        mailType: 'نوع المراسل'
      };

      const typeName = typeMessages[this.deleteType] || 'العنصر';
      return `هل أنت متأكد من حذف ${typeName} "${this.itemToDelete.name}"؟`;
    },

    async saveTemplateCategory() {
      try {
        // Prepare data according to API specification
        const categoryData = {
          name: this.templateCategoryForm.name
        };

        if (this.editingTemplateCategory) {
          await mailTemplateCategoryService.updateMailTemplateCategory(this.editingTemplateCategory.id, categoryData);
        } else {
          await mailTemplateCategoryService.createMailTemplateCategory(categoryData);
        }

        await this.loadTemplateCategories();
        this.closeTemplateCategoryDialog();
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: this.editingTemplateCategory ? 'تم تحديث فئة القالب بنجاح' : 'تم إضافة فئة القالب بنجاح'
        });
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في حفظ فئة القالب'
        });
      }
    },

    closeTemplateCategoryDialog() {
      this.showTemplateCategoryDialog = false;
    },

    // Mail Types Methods
    async loadMailTypes() {
      this.loading = true;
      try {
        const response = await mailTypeService.getMailTypes();
        // Handle paginated response - extract data array
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.mailTypes = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          this.mailTypes = response.data;
        } else {
          this.mailTypes = [];
        }
        //console.log('Loaded mail types:', this.mailTypes);
      } catch (error) {
        console.error('Failed to load mail types:', error);
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في جلب أنواع المراسلات'
        });
      } finally {
        this.loading = false;
      }
    },

    openAddMailTypeDialog() {
      this.editingMailType = null;
      this.mailTypeForm = {
        name: '',
        desc: '',
        active: 1
      };
      this.showMailTypeDialog = true;
    },

    editMailType(item) {
      this.editingMailType = item;
      this.mailTypeForm = {
        name: item.name,
        desc: item.desc,
        active: item.active ? 1 : 0
      };
      this.showMailTypeDialog = true;
    },

    deleteMailType(item) {
      this.itemToDelete = item;
      this.deleteType = 'mailType';
      this.deleteDialog = true;
    },

    async saveMailType() {
      try {
        // Prepare data according to API specification
        const mailTypeData = {
          name: this.mailTypeForm.name,
          desc: this.mailTypeForm.desc,
          active: this.mailTypeForm.active ? 1 : 0
        };

        if (this.editingMailType) {
          await mailTypeService.updateMailType(this.editingMailType.id, mailTypeData);
        } else {
          await mailTypeService.createMailType(mailTypeData);
        }

        await this.loadMailTypes();
        this.closeMailTypeDialog();
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: this.editingMailType ? 'تم تحديث نوع المراسل بنجاح' : 'تم إضافة نوع المراسل بنجاح'
        });
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: error.message || 'فشل في حفظ نوع المراسل'
        });
      }
    },

    closeMailTypeDialog() {
      this.showMailTypeDialog = false;
    }
  }
}
</script>

<style scoped>
.settings-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.v-data-table {
  background: white;
  border-radius: 8px;
}

.v-tabs {
  background: white;
}

.v-window-item {
  background: white;
}

.selected-permission {
  background-color: #e3f2fd !important;
  border-radius: 4px;
  border-left: 3px solid #1976d2;
}

.selected-permission .v-list-item-title {
  color: #1976d2;
  font-weight: 500;
}

/* Fix checkbox visibility - force all elements to be visible */
.permission-checkbox {
  opacity: 1 !important;
  width: auto;
}

.permission-checkbox :deep(*) {
  opacity: 1 !important;
  width: auto;
}

.permission-checkbox :deep(.v-selection-control) {
  opacity: 1 !important;
  width: auto;
}

.permission-checkbox :deep(.v-selection-control__wrapper) {
  opacity: 1 !important;
  width: auto;  
}

.permission-checkbox :deep(.v-selection-control__input) {
  opacity: 1 !important;
  width: auto;
}

.permission-checkbox :deep(.v-icon) {
  opacity: 1 !important;
  display: inline-block !important;
  visibility: visible !important;
  transform: scale(0.5) !important;
  width: auto;
}

/* Unchecked state - show empty checkbox */
.permission-checkbox :deep(.v-selection-control__input:not(.v-selection-control__input--checked) .v-icon) {
  color: #666666 !important;
  width: auto;
}

/* Checked state - show green checkmark */
.permission-checkbox :deep(.v-selection-control__input--checked .v-icon) {
  color: #4CAF50 !important;
  display: inline-block !important;
  visibility: visible !important;
  width: auto;
  }

/* Force Material Design Icons to work */
.permission-checkbox :deep(.mdi) {
  opacity: 1 !important;
  visibility: visible !important;
  display: inline-block !important;
  width: auto;
}

.permission-checkbox :deep(.mdi-checkbox-blank-outline) {
  color: #666666 !important;
  width: auto;
}

.permission-checkbox :deep(.mdi-checkbox-marked) {
  color: #4CAF50 !important;
  width: auto;
}
</style> 